module.exports = __webpack_public_path__ + "MadLibs_logo_no_Phil.png?e52b3c6e9336c4f2fe2a35cff9c9a507";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MadLibs_logo_no_Phil.png
// module id = 580
// module chunks = 0